import { mapLinkList } from './linkListMapper';
import { Props as LinkListProps } from './linkListMapper';
import logger from '3-foundation/Logging/logger';

interface Props {
	content: {
		contentType: 'linkListGrid';
		properties: {
			items: {
				items: { content: LinkListProps }[];
			};
		};
	};
}

export function mapLinkListGrid({ content }: Props): Content.LinkListGrid {
	try {
		if (!content) throw new Error('Invalid linkListGrid content');

		return {
			documentType: 'linkListGrid',
			content: {
				items: content.properties?.items?.items?.map(({ content }) => mapLinkList({ content })).filter(Boolean) ?? [],
			},
		};
	} catch (e) {
		logger.error('Could not map LinkListGrid', e);
		throw new Error('Could not map LinkListGrid', e);
	}
}
